import React, { Component } from 'react';
import {
  FindImage,
  InnerText,
  FindYourOrganizationHeading,
  DarkFindOrganizationWrapper
} from './styles';
import { LoginContentHeading } from '../styles';

class DarkFindOrganization extends Component {
  render() {
    return (
      <div className={DarkFindOrganizationWrapper}>
        <FindImage>
          <img
            src="https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/images/search-organization.png"
            alt="Lyearn"
            className="logoImage"
          />
        </FindImage>
        <LoginContentHeading className={FindYourOrganizationHeading}>
          Find your Lyearn organization.
        </LoginContentHeading>
        <InnerText>Kindly contact your administrator regarding your organization name.</InnerText>
      </div>
    );
  }
}

export default DarkFindOrganization;
